module.exports = __webpack_public_path__ + "Star-review.69a10d639b3ebf3e077ecdf2e34edf9c.png";